import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import newMap from '@/views/base/component/newMap.vue';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction, httpAction } from '@api/manage';
import { queryFileList, queryInspectionTree, queryTemplateTowList, queryUserTreeList } from '@api/api';
import moment from 'moment';
import pick from 'lodash.pick';
import VueAMap from 'vue-amap'; //注意不要和 AMap原始名称覆盖

var amapManager = new VueAMap.AMapManager();
import explainDetaulModal from "../components/explainDetaulModal.vue";
import Img from "../../../visual/dataScreen/js/option/components/img";
/* table 巡检信息表头展示参数*/

var columns = [
/*title: '排序',
dataIndex: 'id',
scopedSlots: { customRender: 'id'*/
{
  title: '排序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%',

  /*scopedSlots: { customRender: 'recordId' }*/
  customRender: function customRender(text, record, index) {
    if (record.templateId && text != null) {
      return text;
    } else {
      return '-';
    }
  }
}, {
  title: '工艺名称及子项',
  dataIndex: 'name',
  align: 'left',
  width: '15%',
  scopedSlots: {
    customRender: 'name'
  } // customRender: (text, record, index) => {
  //   if (record.templateId && text != null) {
  //     return text
  //   } else {
  //     return '-'
  //   }
  // },

}, {
  title: '检查项',
  dataIndex: 'pname',
  align: 'center',
  width: '12%',
  customRender: function customRender(text, record, index) {
    /*if (text == null) {
      return '-'
    } else {
      return text
    }*/
    if (record.coordinateDifference == 0 && text == null) {
      return '-';
    } else {
      return record.name;
    }
  }
}, {
  title: '默认情况',

  /*dataIndex: 'val',*/
  dataIndex: 'defaultValue',
  align: 'center',
  width: '18%',
  customRender: function customRender(text) {
    if (text == null) {
      return '-';
    } else {
      return text;
    }
  }
}, {
  title: '实际情况说明',

  /*dataIndex: 'val',*/
  dataIndex: 'valText',
  align: 'center',
  width: '18%',
  customRender: function customRender(text, record, index) {
    if (text != null && text != 'null') {
      return text;
    } else {
      return '-';
    }
  }
  /*customRender: (text) => {
    if (text == null) {
      return '-'
    } else if (text != null){
      return text
    }
  }*/

}, {
  title: '现场照片',
  dataIndex: 'pictures',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'pictures'
  }
}];
/* DataSource 定义表格数据源数组*/

var data1 = [];
export default {
  name: 'InspectionRecordModal',
  mixins: [ModalFormMixin],
  components: {
    Img: Img,
    newMap: newMap,
    explainDetaulModal: explainDetaulModal
  },
  // 导入地图
  data: function data() {
    return {
      mapPointList: [],
      mapStyle: 'amap://styles/darkblue',
      //设置地图样式
      amapManager: amapManager,
      center: [118.047928, 24.613341],
      zoom: 12,
      plugin: [{
        pName: 'MapType',
        defaultType: 0,
        showRoad: false,
        showButton: false,
        showTraffic: false,
        events: {
          init: function init(o) {}
        }
      }],

      /* 站点名称*/
      siteName: '',

      /* 站点ID*/
      siteId: null,

      /* 模板列表*/
      templateOptions: [],
      // 巡检信息表头
      columns: columns,
      // 巡检信息表格数据
      data1: data1,
      queryParam: {},
      // 隐藏第二三面板
      showTab: false,
      // 抽屉默认面板
      paneChange: '1',
      // 图片相关 图片id
      imgId: '',
      // 是否显示图片
      showImgModal: false,
      // 模板预设坐标集
      templateCoordinateSet: [],
      // 人员信息
      userTree: [],
      modalName: '现场图片',
      title: '巡检记录表单',
      tableName: 'om_inspection_record',
      form_fields: ['category', 'siteId', 'userId', 'templateId', 'weather', 'temperature', 'humidity', 'realCoordinate', 'remark', 'status', 'details'],
      form_fields_time: ['stime', 'etime'],
      validatorRules: {
        category: {
          rules: [{
            required: true,
            message: '请选择巡检类型!'
          }]
        },
        siteId: {
          rules: [{
            required: true,
            message: '请输入巡检站点!'
          }]
        },
        templateId: {
          rules: [{
            required: true,
            message: '请输入巡检模板!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择巡检模板!'
          }]
        }
      },
      url: {
        tree: '/om/inspection/point/tree/',
        imageUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      }
    };
  },
  props: ['pagePath'],
  created: function created() {
    // 加载巡检模板列表
    this.queryTemplateList();
    /* 渲染地图数据pointCoordinateSet*/

    this.loadInspectionTree();
    this.siteName = sessionStorage.getItem('siteName');
  },
  methods: {
    // 编辑
    edit: function edit(record) {
      var _this = this;

      record.manualSign = decodeURIComponent(record.manualSign);
      this.data1 = [];
      this.loadTreeList();
      this.queryTemplateList(); //debugger
      // 加载巡检模板列表

      this.form.resetFields();
      this.model = Object.assign({}, record);
      console.log('this.model', this.model);
      this.visible = true;

      if (this.model.id) {} else {
        this.model.siteId = this.siteId;
        this.model.siteName = this.siteName;
      }
      /* this.data1 = []
       this.formItem.resetFields()*/
      //通过模板id查询模板预设坐标集templateId


      if (record.templateId) {
        this.queryTemplateCoordinateSetList(record.templateId);
      }
      /*if (this.model.id != null) {
        // 编辑
        this.getRelatedTypeList(this.model.category, this.model.relatedType)
        //this.siteChange(this.model.relatedType)
      } else {
        setTimeout(() => {
          // 添加
          this.form.setFieldsValue({ status: '1' })
          this.form.setFieldsValue({ isGps: '1' })
        }, 300)
      }*/


      this.$nextTick(function () {
        if (!record.id) {
          _this.form.setFieldsValue({
            category: '1'
          });

          _this.form.setFieldsValue({
            status: '1'
          });
        } else {
          _this.model.category = _this.model ? _this.model.category ? _this.model.category.toString() : null : null;
          _this.model.status = _this.model ? _this.model.status ? _this.model.status.toString() : null : null;
        }

        _this.form.setFieldsValue(pick(_this.model, _this.form_fields)); // 时间格式化


        _this.form.setFieldsValue({
          stime: _this.model.stime ? moment(_this.model.stime) : null
        });

        _this.form.setFieldsValue({
          etime: _this.model.etime ? moment(_this.model.etime) : null
        });
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this2 = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this2.loading = false;
        }
      });
    },

    /* 通过模板id查询模板预设坐标集templateId*/
    queryTemplateCoordinateSetList: function queryTemplateCoordinateSetList(templateId) {
      var that = this;
      queryTemplateTowList({
        id: templateId
      }).then(function (Template) {
        if (Template.success) {
          that.templateCoordinateSet = Template.result.records;
        }
      });
    },
    coordinateOk: function coordinateOk(value) {
      var that = this;

      if (value != null) {
        var a = '';
        value.forEach(function (element, index) {
          var b = '';
          element.forEach(function (item, i) {
            b += i == element.length - 1 ? item.join(',') : item.join(',') + '-';
          });
          a += index == value.length - 1 ? b : b + ':';
        }); // console.log(a, '抽屉2')

        this.form.setFieldsValue({
          coordinate: value ? a : null
        });
        this.model.coordinate = value ? a : null;
      }
    },
    coordinateChange: function coordinateChange() {
      // console.log(this.model.coordinate)
      this.$refs.mapLine.show(this.model.coordinate);
    },
    // 查看文件
    openFile: function openFile(text) {
      var _this3 = this;

      if (!text) {
        this.$message.warning('未知的文件');
        return;
      }

      this.imgId = '';
      this.$nextTick(function () {
        _this3.imgId = _this3.getImgView(text);
        _this3.showImgModal = true;
      });
    },
    // 图片预览
    getImgView: function getImgView(text) {
      return this.url.imgerver + '/' + text;
    },
    // 现场图片关闭
    setModal1Visible: function setModal1Visible() {
      this.showImgModal = false;
    },
    // add() {
    //   this.edit({})
    // },
    handleOk: function handleOk() {
      var _this4 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this4.model.id) {
            httpurl = _this4.url.add ? _this4.url.add : _this4.pagePath;
            method = 'post';
          } else {
            httpurl = _this4.url.edit ? _this4.url.edit : _this4.pagePath;
            method = 'put';
          }

          var formData = Object.assign(that.model, values);
          formData.siteId = that.siteId;
          formData.stime = formData.stime ? moment(formData.stime) : null;
          formData.stime = formData.stime ? formData.stime.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.etime = formData.etime ? moment(formData.etime) : null;
          formData.etime = formData.etime ? formData.etime.format('YYYY-MM-DD HH:mm:ss') : null;
          /* formData.planSdate = that.planDateData.planSdateBack
           formData.planEdate = that.planDateData.planEdateBack*/

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    close: function close() {
      this.templateOptions = []; // 巡检模板制空

      this.hiddenButton = true; // 设为true 每次关闭重置  不影响确定按钮的&&

      this.$emit('close');
      this.visible = false;
      this.paneChange = '1'; // 抽屉框永远显示第一面板 可避免点击更多编辑后选择第二个面板，再关闭后点击新增时显示不正常
    },
    // 切换面板时重载
    handleTabChange: function handleTabChange(key) {
      var _this5 = this;

      if (key == '1') {
        this.hiddenButton = true; // 展示本页面确定取消
      }

      this.paneChange = key;

      if (key == '2') {
        if (this.model.status != null) {
          //this.model.status ==2 todo
          this.loadInspectionTree();
        }

        this.hiddenButton = false; // 隐藏本页面确定取消
      }

      if (key == '3') {
        console.log('this.model', this.model);
        console.log('this.templateCoordinateSet', this.templateCoordinateSet);
        var that = this;
        var pointCoordinateSetItem = [];
        that.hiddenButton = false; // 隐藏本页面确定取消

        queryInspectionTree(that.model.id).then(function (res) {
          if (res.success) {
            /* 取出点位坐标缓存在pointCoordinateSetItem坐标集中*/
            var polyLine = [];
            res.result.forEach(function (tree) {
              pointCoordinateSetItem.push(tree.coordinate.split(','));
              var obj = {
                childArr: []
              };
              obj.childArr.push({
                coordinate: tree.realCoordinate,
                imageId: tree.imageId,
                name: tree.name
              });
              polyLine.push(obj);
            });
            console.log('pointCoordinateSetItem', pointCoordinateSetItem);
            _this5.center = pointCoordinateSetItem[0]; // 只展示预设点位坐标 图标

            if (that.model.realCoordinate) {
              that.center = that.model.realCoordinate.split('-')[0];
              that.show(that.model.realCoordinate, polyLine);
            } else if (that.templateCoordinateSet.length > 0) {
              // 解开可看到每分钟12次获取的真实数据

              /*that.show(this.model.routes, pointCoordinateSetItem)*/
              that.show(that.templateCoordinateSet[0].coordinate, polyLine);
            } else {
              that.show('', polyLine);
            }
          }
        });
      }
    },
    // 加载巡检记录对应的巡检点point和巡检内容items
    loadInspectionTree: function loadInspectionTree() {
      var that = this;
      /* 记录的id*/

      var params = that.model.id;
      queryInspectionTree(params).then(function (res) {
        if (res.success) {
          /*that.getChild(res)*/

          /* 取出点位坐标缓存在pointCoordinateSet坐标集中*/

          /*res.result.forEach((tree) => {
            that.pointCoordinateSet.push(tree.coordinate)
          })*/
          res.result.forEach(function (item, index) {
            that.toTreePicture(item);

            if (item.children == null && item.items != null) {
              item.children = item.items;
              item.children.forEach(function (i) {
                if (item.name != null) i.pname = item.name;
              });
            }
          });
          /* 数据复杂还没渲染完，dom元素已经加载完成 所以做延时处理*/

          setTimeout(function () {
            that.data1 = res.result;
          }, 800);
        }
      });
    },

    /* 递归获取图片*/
    toTreePicture: function toTreePicture(item) {
      var _this6 = this;

      if (item.imageId) {
        queryFileList('om_inspection_record_point', item.imageId).then(function (vo) {
          if (vo.success) {
            item.pictures = vo.result;
          }
        });

        if (item.children) {
          item.children.forEach(function (item, index) {
            _this6.toTreePicture(item);
          });
        }
      } else {
        return;
      }
    },

    /* 加载 模板列表*/
    queryTemplateList: function queryTemplateList() {
      var that = this;
      that.templateOptions = [];
      getAction('/om/inspection/template', {
        pageNo: 1,
        status: 1,
        pageSize: 10000
      }).then(function (res) {
        if (res.success) {
          // 模板类型
          that.templateOptions = res.result.records;
          /*this.idItem = res.result
          this.form.setFieldsValue({ code: 'TPL' + moment().format('YYMMDD') + '00' + this.idItem })*/
        } else {
          console.log(res.message);
        }
      });
    },
    show: function show(lines, markerList) {
      var _this7 = this;

      var line = [];

      if (lines) {
        var pointList = lines.split(':');
        line = pointList.map(function (v) {
          return v.split('-').map(function (item) {
            return item.split(',');
          });
        });
      }

      this.mapPointList = _toConsumableArray(line);
      console.log('mapPointList', this.mapPointList);
      this.showTab = false;
      this.$nextTick(function () {
        _this7.showTab = true;

        _this7.$nextTick(function () {
          _this7.$refs.newMap.pipePositionList = _this7.mapPointList;
          _this7.$refs.newMap.areaName = '青岛市';
          _this7.$refs.newMap.pipeMarkerPositionList = markerList;

          _this7.$refs.newMap.initMap();

          _this7.$refs.newMap.drawBounds(1);

          _this7.$forceUpdate();
        });
      });
    },
    // 查看巡检说明详情
    checkExplain: function checkExplain(text, record, index) {
      console.log(this.$refs.explainDetaulModal); // this.$nextTick(() => {

      this.$refs.explainDetaulModal.visible = true;
      this.$refs.explainDetaulModal.getExplainDetaul(record.docId); // })
    }
  }
};